import { render, staticRenderFns } from "./SmartTableWidget.vue?vue&type=template&id=f379a488&scoped=true"
import script from "./SmartTableWidget.vue?vue&type=script&lang=js"
export * from "./SmartTableWidget.vue?vue&type=script&lang=js"
import style0 from "./SmartTableWidget.vue?vue&type=style&index=0&id=f379a488&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f379a488",
  null
  
)

export default component.exports